import { isDate } from 'lodash';

export default function ValidateStringifiedDateValue(dateString: string) {
  if (dateString && !isDate(dateString)) {
    return new Date(dateString);
  }

  return dateString;
}
